import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-946946dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "memeber-profile" }
const _hoisted_2 = { class: "memeber-profile-main" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "list" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ID：", -1))
const _hoisted_6 = { class: "memeber-profile-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "avatar",
        src: _ctx.userInfo?.avatar || 'https://image.iguopin.com/data/app/im-logo.png',
        onerror: "this.src='https://image.iguopin.com/data/app/im-logo.png'"
      }, null, 8, _hoisted_3),
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.userInfo?.nick || _ctx.userInfo?.userID), 1),
        _createElementVNode("li", null, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_ctx.userInfo?.userID), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.userInfo?.selfSignature), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.showEnter())
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enter(_ctx.userInfo?.userID, 'C2C')))
          }, _toDisplayString(_ctx.$t("TUIContact.发送消息")), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}